import { Button } from "@/elements"
import { FC } from "react"

interface Props {
  returnToApply: () => void
  attachmentLength: number
}

export const ApplyToJobSelectWorkFooter: FC<Props> = ({ returnToApply, attachmentLength }) => {
  return (
    <div className="flex h-full w-full flex-row items-center justify-end">
      <Button size="large" variant="primary" className="hidden md:block" onClick={returnToApply}>
        Next {attachmentLength > 0 ? `(${attachmentLength})` : ""}
      </Button>
      <Button variant="primary" className="w-full md:hidden" onClick={returnToApply}>
        Next {attachmentLength > 0 ? `(${attachmentLength})` : ""}
      </Button>
    </div>
  )
}
